import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RESPONSE_CLASS, SKIP_DATE_PARSING } from '@core/services/http/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class HttpDateConverterInterceptor implements HttpInterceptor {
  private _isoDateTimeFormat = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
  private _isoDateFormat = /^\d{4}-\d\d-\d\d$/;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipDateParsing = req.context.get(SKIP_DATE_PARSING);
    if (skipDateParsing) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      map( (val: HttpEvent<any>) => {
        if (val instanceof HttpResponse){
          const body = val.body;
          this.convert(body);
        }
        return val;
      })
    );
  }

  isIsoDateString(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string'){
      return this._isoDateTimeFormat.test(value) || this._isoDateFormat.test(value);
    }
    return false;
  }

  convert(body: any) {
    if (body === null || body === undefined ) {
      return body;
    }
    if (typeof body !== 'object' ){
      return body;
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIsoDateString(value)) {
        body[key] = new Date(value);
      } else if (typeof value === 'object') {
        this.convert(value);
      }
    }
  }
}
